import React, { useCallback, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import dayjs from 'dayjs';
import qs from 'qs';
import * as apis from '@/apis';
import { Alert, Button, Avatar, Affix, Table, Popconfirm, message } from 'antd';
import styles from './transactions.module.scss';
import { orderPreview } from '@/models/orders/actions';
const managerMode = process.env.APP_MODE === 'manager';
function getColumns({ showOrderPreview }) {
  return [
    {
      key: 'transaction',
      title: '',
      width: 30,
      render: (text, record, idx) => (
        <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
      ),
    },
    {
      title: '交易金额',
      render: (item) => (
        <div>
          <span>¥{item.amount?.toFixed(2)}</span>
        </div>
      ),
    },
    {
      title: '交易流水号',
      render: (item) => item.transaction,
    },
    {
      title: '相关工单',
      render: (item, x, idx) => (
        <a onClick={showOrderPreview(item.order, `${idx + 1}. 工单详情`)}>
          点击查看
        </a>
      ),
    },
    {
      title: '交易时间',
      render: (item) => dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];
}

// 所有 交易记录
export default function Transactions({ tenantId }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [total_amount, setTotalAmount] = useState(0);
  const [genLoading, setGenLoading] = useState(false);
  const history = useHistory();

  const paramsCache = useRef({});
  const fetch = useCallback(
    (params = {}) => {
      setLoading(true);
      paramsCache.current = params;

      apis.getUnbilledList(params).then((result) => {
        setLoading(false);
        setList(result.list);
        setTotalAmount(result.total_amount);
      });
    },
    [tenantId]
  );

  useMount(() => {
    fetch({ tenant: tenantId });
  });

  const handleGenBill = useCallback(() => {
    setGenLoading(true);

    apis
      .genBill(
        {
          // records: ['5f0d531929a13f411666d2d4', '5f0ed85090d5cb75aa147237'] // 可选择指定交易生成账单
        },
        {
          tenant: tenantId,
        }
      )
      .then((result) => {
        message.success('已生成');

        history.push(`/enterprises/${tenantId}/bills?type=billed`);
      })
      .catch((error) => {
        message.error(error.message || '未能生成账单，请稍后再试');
      })
      .finally(() => {
        setGenLoading(false);
      });
  }, [tenantId]);

  const undumpBills = useCallback(
    () => {
      apis
        .unbillDump(tenantId)
        .then(res => {
          saveAs(res, `未出账单.csv`)
          // message.success('核对完成，账单已发送给商户');
        })
        .catch((err) => {
          message.error(err.message || '操作失败，请重试');
        });
    },
    [tenantId]
  )

  const showOrderPreview = useCallback(
    (id, title) => (e) => {
      e.preventDefault();

      // TODO 先关闭之前的弹出框，再打开
      dispatch(
        orderPreview({
          title,
          id,
        })
      );
    },
    []
  );
  const columns = getColumns({ showOrderPreview });

  return (
    <div className={styles.wrap}>
      <Table
        size="middle"
        className={styles.table}
        columns={columns}
        dataSource={list}
        pagination={false}
        loading={loading}
      />
      
      <Affix offsetTop={20} className={styles.aside}>
      <Alert message="注意：已生成账单总金额不再改变，如有工单费用变动，将计入下次账单，请按当前账单结算。感谢理解。" banner closable />
        {(managerMode) && (<><Alert message="生成后不可撤回，请谨慎操作。请尽量在每月统一、固定日期生成账单" banner closable /><Popconfirm
          title="确定要手动生成？生成后不可取消"
          onConfirm={handleGenBill}
          okText="确认"
          cancelText="返回"
        >
          <Button style={{ marginTop: 20 }} loading={genLoading} type="primary">
            生成账单
          </Button>
        </Popconfirm></>)
        }
        <Button style={{ marginTop: 20,marginLeft: 5 }} type="primary" onClick={undumpBills}>
            导出账单
          </Button>
        <div style={{ marginTop: 20 }}>
          {list.length}笔交易，共计{total_amount.toFixed(2)}元
        </div>
      </Affix>
    </div>
  );
}
